import FrameBorder from '@/component/FrameBorder';
import Headers from '@/component/Headers';
import UseResponsive from '@/utils/hooks/useResponsive';
import backgroundHeaderHistory from '@assets/web-v3-images/background-Header-History.png';
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { useTranslation } from 'react-i18next';

export default function HelpCenter() {
	const { t } = useTranslation()
	const items = [
		{
			title: t("help_center_page.introduction.title"),
			content: t("help_center_page.introduction.content"),
		},
		{
			title: t("help_center_page.eligibility_registration.title"),
			content: t("help_center_page.eligibility_registration.content"),
		},
		{
			title: t("help_center_page.service_participation.title"),
			content: t("help_center_page.service_participation.content"),
		},
		{
			title: t("help_center_page.turn_packages.title"),
			content: t("help_center_page.turn_packages.content"),
		},
		{
			title: t("help_center_page.winner_selection.title"),
			content: t("help_center_page.winner_selection.content"),
		},
		{
			title: t("help_center_page.prize_pollection.title"),
			content: t("help_center_page.prize_pollection.content"),
		},
		{
			title: t("help_center_page.privacy_user_responsibilities.title"),
			content: t("help_center_page.privacy_user_responsibilities.content"),
		},
		{
			title: t("help_center_page.general_terms.title"),
			content: t("help_center_page.general_terms.content"),
		},
	];

	return (
		<UseResponsive background="linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%)">
			<div className="relative size-full">
				{/* Background */}
				<div aria-hidden className="absolute inset-0 pointer-events-none z-0">
					<img
						alt=""
						className="absolute max-w-none object-cover size-full"
						src={backgroundHeaderHistory}
					/>
				</div>

				{/* Content */}
				<div className="pb-7 relative z-10"
					style={{
						backgroundImage: `url(${backgroundHeaderHistory})`,
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "top center",
					}}
				>
					<div className='pt-26'>
						<Headers title={t("help_center")} />
					</div>
					<div className="flex px-6 gap-4 overflow-x-auto  
									pt-7
									sm:pt-4
									md:pt-4
									lg:pt-22
									pb-3
									">
						<FrameBorder>
							<Accordion.Root
								type="single"
								collapsible
								className="w-full p-5"
							>
								{items.map((item, index) => (
									<Accordion.Item
										key={index}
										value={`item-${index}`}
										className="border-b border-[#F4D4B3]"
									>
										<Accordion.Header>
											<Accordion.Trigger
												className="
											flex
											w-full
											items-center
											justify-between
											py-5
											text-left
											text-[rgba(113,59,18,1)]
											text-[30px]
											group
											font-semibold
										"
											>
												{item.title}
												<ChevronDownIcon
													className="
												h-10
												w-10
												transition-transform
												duration-300
												group-data-[state=open]:rotate-180
											"
												/>
											</Accordion.Trigger>
										</Accordion.Header>

										<Accordion.Content
											className="
										overflow-hidden
										data-[state=open]:animate-slideDown
										data-[state=closed]:animate-slideUp
									"
										>
											{item.content &&
												<div className="p-5
												text-[#854A0E]
												bg-[#FEF6EE]
												font-medium
												rounded-2xl
												mb-[4%]
												text-[25px]
												max-h-[500px]
												overflow-y-auto
												scrollbar-thin
												scrollbar-thumb-[#E6B97D]
												scrollbar-track-transparent">
													<div
														dangerouslySetInnerHTML={{
															__html: item.content.replace(/\n\n/g, "<br/><br/>").replace(/\n/g, "<br/>"),
														}}
													/>
												</div>
											}
										</Accordion.Content>
									</Accordion.Item>
								))}
							</Accordion.Root>
						</FrameBorder>
					</div>
				</div>
			</div>
		</UseResponsive>
	)
}
